var map = {
	"./bootS.png": 188,
	"./ehmal.jpg": 189,
	"./google.png": 56,
	"./hadaf.jpg": 190,
	"./khat.jpg": 191,
	"./khod.jpg": 192,
	"./slide.jpg": 193,
	"./vbinaar.jpg": 194,
	"./wordPress.jpg": 195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88;